module.exports = __webpack_public_path__ + "img/partner30.32f65006.png";